import { createSlice } from "@reduxjs/toolkit";
import { useInjectReducer } from "utils/@reduxjs/useInjectReducer";
import { useInjectSaga } from "utils/@reduxjs/useInjectSaga";
import { rosterImportSaga } from "./saga";

export const initialState = {
  rosterRequests: {
    initialLoading: true,
    loading: false,
    error: null,
    total_count: 0,
    completed_requests: 0,
    pending_requests: 0,
    rosters: [],
    pagination: { page: 1, limit: 10, total_pages: 1 },
    status: "pending" //  store current tab
  }
};

export const RosterImportSlice = createSlice({
  name: "rosterImport",
  initialState,
  reducers: {
    fetchRosterRequests: (state, action) => {
      state.rosterRequests.loading = true;
      if (state.rosterRequests.initialLoading) {
        // only for first mount
        state.rosterRequests.initialLoading = true;
      }
      state.rosterRequests.error = null;
      if (action.payload?.status)
        state.rosterRequests.status = action.payload.status;
    },
    fetchRosterRequestsSuccess: (state, action) => {
      const {
        total_count,
        completed_requests,
        pending_requests,
        rosters,
        pagination
      } = action.payload;
      state.rosterRequests.loading = false;
      state.rosterRequests.initialLoading = false; // first load is done
      state.rosterRequests.error = null;
      state.rosterRequests.total_count = total_count;
      state.rosterRequests.completed_requests = completed_requests;
      state.rosterRequests.pending_requests = pending_requests;
      state.rosterRequests.rosters = rosters;
      state.rosterRequests.pagination = pagination;
    },
    fetchRosterRequestsFailure: (state, action) => {
      state.rosterRequests.loading = false;
      state.rosterRequests.initialLoading = false; // stop initial loading
      state.rosterRequests.error = action.payload;
    },

    updateRosterRequest: (state) => {
      state.rosterRequests.loading = true;
      state.rosterRequests.error = null;
    },
    updateRosterRequestSuccess: (state, action) => {
      const updatedRoster = action.payload;
      state.rosterRequests.loading = false;
      state.rosterRequests.error = null;
      state.rosterRequests.rosters = state.rosterRequests.rosters.map(
        (roster) =>
          roster.id === updatedRoster.id
            ? { ...roster, ...updatedRoster }
            : roster
      );
    },
    updateRosterRequestFailure: (state, action) => {
      state.rosterRequests.loading = false;
      state.rosterRequests.error = action.payload;
    }
  }
});

export const useRosterImportSlice = () => {
  useInjectReducer(RosterImportSlice.name, RosterImportSlice.reducer);
  useInjectSaga(RosterImportSlice.name, rosterImportSaga);
  return { actions: RosterImportSlice.actions };
};

export const { actions: rosterImportActions } = RosterImportSlice;
export default RosterImportSlice.reducer;
